
export const badgeColor = (label) => {
  switch (label) {
    case 'Excellent':
      return '#12B981';
    case 'Good':
      return '#10B981';
    case 'Poor':
      return '#EF4444';
    default:
      return '#9CA3AF';
  }
};
export const formatDateShort = (date) =>
  new Date(date).toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
export const normalizeBP = (scan) => {
  if (scan?.sbp && scan?.dbp) return `${scan.sbp}/${scan.dbp}`;
  return scan?.blood_pressure || '--';
};
// Neutral wording, matching HealthSeer's Health Twin severity labels
// (Monitor / High Attention) rather than clinical "abnormal/critical".
export const vitalStatusLabel = (status) => {
  switch (status) {
    case 'normal':
      return 'Normal';
    case 'abnormal':
      return 'Monitor';
    case 'critical':
      return 'High Attention';
    case 'Low':
        return 'Low';
    case 'Normal':
        return 'Normal';
    case 'Moderate':
        return 'Moderate';
    case 'High':
        return 'High';
    case 'Very High':
        return 'Very High';
    default:
      return 'Unavailable';
  }
};
export const vitalStatusColor = (status) => {
  switch (status) {
    case 'normal':
      return { bg: '#E8F9F6', text: '#0F766E' };
    case 'abnormal':
      return { bg: '#FFF7ED', text: '#B45309' };
    case 'critical':
      return { bg: '#FEE2E2', text: '#B91C1C' };
    case 'Low':
        return { bg: '#E0F2FE', text: '#0369A1' };
    case 'Normal':
        return { bg: '#E8F9F6', text: '#0F766E' };
    case 'Moderate':
        return { bg: '#FEF3C7', text: '#92400E' };
    case 'High':
    case 'Very High':
        return { bg: '#FEE2E2', text: '#B91C1C' };
    default:
      return { bg: '#F3F4F6', text: '#6B7280' };
  }
};
